var link = {
    base: {
        font: "body",
        color: "action-foreground",
        textDecoration: "none",
        ":hover[data-disabled=true]": { cursor: "default" },
        ":hover:not([data-disabled=true])": { textDecoration: "underline" },
        "&[aria-current]": {
            color: "brandDark.100",
        },
    },
};

export { link };
//# sourceMappingURL=link.js.map
